var EventEmitter, local, poet, req;

EventEmitter = require('events').EventEmitter;

module.exports = poet = new EventEmitter;

local = {
  text: '',
  start: 0
};

req = new XMLHttpRequest;

req.open('GET', './data/piece.txt');

req.send();

req.onload = function() {
  local.text = req.responseText.replace(/\n/g, '');
  return poet.emit('load');
};

poet.read = function(len) {
  var text;
  if ((len + local.start) > local.text.length) {
    local.start = 0;
  }
  text = local.text.slice(local.start, local.start + len);
  local.start += len;
  return text;
};
